import dynamic from 'next/dynamic';
import Head from 'next/head';
import { PUBLIC_WEBSITE_URL, WEBSITE_SEO, organizationStructuredData } from './content';
import PcWebsite from './PcWebsite';
import type { WebsitePageProps } from './types';
import styles from './WebsitePage.module.scss';

const MobileWebsite = dynamic(() => import('@/modules/h5'), { ssr: false });

export default function WebsitePage({ deviceVariant, isLoggedIn, saleMemberKind, viewer }: WebsitePageProps) {
  return (
    <>
      <Head>
        <title>{WEBSITE_SEO.title}</title>
        <meta name='description' content={WEBSITE_SEO.description} />
        <meta name='keywords' content={WEBSITE_SEO.keywords} />
        <meta name='robots' content='index,follow,max-image-preview:large' />
        <meta name='renderer' content='webkit' />
        <meta name='baidu-site-verification' content='code-pAKG6wVl61' />
        <meta name='sogou_site_verification' content='juxgLQqIro' />
        <meta name='360-site-verification' content='40f694b561456a9a317464a35d81392d' />
        <meta name='bytedance-verification-code' content='TatfF0rKG+uPdHdYbLqb' />
        <link rel='canonical' href={PUBLIC_WEBSITE_URL} />
        <meta property='og:type' content='website' />
        <meta property='og:locale' content='zh_CN' />
        <meta property='og:site_name' content='脉脉' />
        <meta property='og:title' content={WEBSITE_SEO.title} />
        <meta property='og:description' content={WEBSITE_SEO.description} />
        <meta property='og:url' content={PUBLIC_WEBSITE_URL} />
        <meta property='og:image' content={WEBSITE_SEO.shareImage} />
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationStructuredData) }}
        />
      </Head>

      <div className={styles.websiteRouteRoot} data-device-variant={deviceVariant} data-testid='website-root'>
        <h1 className={styles.srOnly}>脉脉：1.2亿职场人都在用的职场社区和求职平台</h1>
        {deviceVariant === 'mobile' ? (
          <MobileWebsite />
        ) : (
          <PcWebsite isLoggedIn={isLoggedIn} saleMemberKind={saleMemberKind} viewer={viewer} />
        )}
      </div>
    </>
  );
}
